// @ts-ignore
export const zhcn  = () => import("https://lint.eci.games/api/lqa-game/system/language/data/byLanguage/zh/comic/conten.js?lang=zh-cn");
// @ts-ignore
export const en  = () => import("https://lint.eci.games/api/lqa-game/system/language/data/byLanguage/en/comic/conten.js?lang=en");
// @ts-ignore
export const hk  = () => import("https://lint.eci.games/api/lqa-game/system/language/data/byLanguage/hk/comic/conten.js?lang=hk");
// @ts-ignore
export const ka  = () => import("https://lint.eci.games/api/lqa-game/system/language/data/byLanguage/ka/comic/conten.js?lang=ka");
// @ts-ignore
export const ja  = () => import("https://lint.eci.games/api/lqa-game/system/language/data/byLanguage/ja/comic/conten.js?lang=ja");